<div class="google-maps">
    @if (apiLoaded()) {
        <google-map
            height="100%"
            width="100%"
            [center]="center()"
            [zoom]="zoom()"
            [options]="options">
            <map-marker [position]="center()" />
        </google-map>
    } @else {
        <div class="map-loading">Loading Map...</div>
    }
</div>
